/**
 * The content column, shared by the app header and every view.
 *
 * Capped rather than full-bleed, so a bar chart never stretches across a 2560px
 * monitor — but the cap grows, because a fixed 1152px left 384px of dead gutter
 * on each side of a 1920px window and the dashboard read as a phone layout
 * stretched onto a desktop.
 *
 * One token rather than a copy per view. The header, the filter bars and the
 * panels all have to agree: a header that runs edge to edge above a capped
 * column puts the brand and the account controls out over empty margin, with a
 * hole in the middle where `ms-auto` pushed them apart — measured at 409px on a
 * 1213px window, and it grows with the screen.
 */
export const CONTENT_WIDTH = 'mx-auto w-full max-w-6xl xl:max-w-7xl 2xl:max-w-[1600px]';
